export default function showLoadingAlert(action = 'procesando') {
    const me = this
    const messages = {
        guardar: 'Estamos guardando la información, espera...',
        eliminar: 'Estamos eliminando la información, espera...',
        actualizar: 'Estamos actualizando la información, espera...',
        procesando: 'Estamos procesando la información, espera...',
        consulta: 'Estamos consultando la información, espera...',
        descargar: 'Estamos descargando la información, espera...',
        timbrar: 'Estamos timbrado la factura, espera...',
    }

    this.$swal({
        title: messages[action] || messages.procesando,
        allowOutsideClick: false,
        confirmButtonText: 'Aceptar',
        showConfirmButton: false,
        didOpen: () => {
            me.$swal.showLoading()
        },
    })
}
